const styles = {
  wrapper: {
    display: 'flex',
    gap: '24px',
  },
  contrastBg: {
    borderRadius: '24px',
    backgroundColor: '#F4F2FA',
  },
  aiSection: {
    minWidth: '100px',
    display: 'flex',
  },
  aiLogosWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  item: {
    padding: 0,
    position: 'relative',
  },
  imageWrapper: {
    display: 'block',
    height: {
      xs: '32px',
      xl: '63px',
    },
  },
  imageBlock: {
    height: '100%',
    width: '100%',
  },
  image: {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
  },
};

export default styles;
